import {
  Component,
  ContentChildren,
  QueryList,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
  Renderer2,
  DoCheck
} from '@angular/core';
import { WithSubscriptionComponent } from '@sabstravtech/obtservices/angular';

import { LightToggleBtnComponent } from '../light-toggle-btn/light-toggle-btn.component';
import { LightToggleBtn } from '../../core/interfaces/light-toggle-btn.interface';

@Component({
  selector: 'app-light-toggle-group',
  templateUrl: './light-toggle-group.component.html',
  styleUrls: ['./light-toggle-group.component.scss'],
  standalone: false
})
export class LightToggleGroupComponent
  extends WithSubscriptionComponent
  implements AfterViewInit, DoCheck
{
  @ContentChildren(LightToggleBtnComponent, { read: LightToggleBtnComponent })
  lightToggleBtns: QueryList<LightToggleBtnComponent>;

  @ViewChild('floater') floater: ElementRef;

  @Output() public change: EventEmitter<LightToggleBtn> = new EventEmitter();
  activeIndex = 1;
  finishResize: any;
  width = -1;

  constructor(private renderer: Renderer2) {
    super();
  }

  ngDoCheck(): void {
    if (
      this.lightToggleBtns &&
      this.lightToggleBtns.first &&
      this.width !== this.lightToggleBtns.first.elementRef.nativeElement.clientWidth
    ) {
      this.ngAfterViewInit();
    }
  }

  ngAfterViewInit(): void {
    let beenSet = false;
    (this.lightToggleBtns || []).forEach((btn, index) => {
      if (btn.selected) {
        this.pinFloaterTo(index);
        beenSet = true;
      }
      if (!beenSet) {
        this.pinFloaterTo(0);
      }
      this.subscribe(btn.clicked, (btnRef: LightToggleBtn) => {
        (this.lightToggleBtns || []).forEach((ltb) => ltb.setActive(false));
        btn.toggle();
        this.change.emit(btnRef);
        this.activeIndex = index;
        this.pinFloaterTo();
      });
    });
  }

  @HostListener('window:resize', [])
  pinFloaterTo(index: number = this.activeIndex) {
    if (this.lightToggleBtns) {
      const selectableBtns = this.lightToggleBtns.filter((btn) => !btn.isLink);
      if (!selectableBtns.length) return;

      const firstBtn = selectableBtns[0].elementRef.nativeElement;
      const isVertical = window.innerWidth <= 767;

      this.width = firstBtn.clientWidth;
      this.renderer.setStyle(this.floater.nativeElement, 'transition', 'none');

      if (isVertical) {
        const targetBtn = selectableBtns[index]?.elementRef.nativeElement ?? firstBtn;
        this.renderer.setStyle(this.floater.nativeElement, 'width', '100%');
        this.renderer.setStyle(this.floater.nativeElement, 'height', `${targetBtn.clientHeight}px`);
        this.renderer.setStyle(this.floater.nativeElement, 'left', '0');
        this.renderer.setStyle(this.floater.nativeElement, 'top', `${targetBtn.offsetTop}px`);
      } else {
        const btnWidth = firstBtn.clientWidth;
        this.renderer.setStyle(this.floater.nativeElement, 'width', `${btnWidth}px`);
        this.renderer.setStyle(this.floater.nativeElement, 'height', '100%');
        this.renderer.setStyle(this.floater.nativeElement, 'top', '0');
        this.renderer.setStyle(this.floater.nativeElement, 'left', `${index * btnWidth}px`);
      }

      this.renderer.setStyle(this.floater.nativeElement, 'transition', 'ease-in-out .2s');
    }
  }
}
